module.exports = "<form :skin=skins.form :id=id class=\"Form Form--standard animated fadeIn\"><div class=Form__body><partial name=rawhtml></partial></div></form>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/forms/standard.vue
// module id = 427
// module chunks = 0